window.addEventListener('load', function() {
    var ordersDirectory = document.querySelector('.orders-table');
    if (ordersDirectory) {
        var OrdersManager = require('../modules/OrdersManager');
        var m = new OrdersManager(ordersDirectory);
    }
    var ordersPickup = document.querySelector('.orders-pickup-form');
    if (ordersPickup) {
        var OrdersPickup = require('../modules/OrdersPickup');
        var m = new OrdersPickup();
    }
});